<template>
    <component :is="dynamicComponent" class="eui-a-heading" :class="[`-h${level}`, {'-bold': bold === true}]">
        <slot/>
    </component>
</template>

<script>
    export default {
        name: "Heading",
        props: {
            level: {
                type: Number,
                required: true,
                validator(value) {
                    return value > 0 && value < 5;
                }
            },
            bold:  {
              type: Boolean,
              default: true,
            }
        },
        computed: {
            dynamicComponent() {
                if (this.level > 0 && this.level < 5) {
                    return `h${this.level}`;
                }
                throw new Error(`Heading component invalid props value: level should not be ${this.level}`);
            }
        }
    }
</script>
